import { Component, inject, Input, ChangeDetectionStrategy } from "@angular/core";
import { SelectedListItem } from "~app/common/components/list-selected-items/listSelectedItems.models";
import { ModalComponentMediator } from "~app/common/components/modal/modal-component-mediator";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { GenericFeatureInfo } from "../import-geometries-models";

@Component({
    selector: "rask-file-select-dialog",
    imports: [RaskCommonModule],
    templateUrl: "./file-select-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./file-select-dialog.component.scss"
})
export class FileSelectDialogComponent {
    filer: SelectedListItem[];
    importCallback: (selectedFiles: SelectedListItem[], features: GenericFeatureInfo[]) => void;
    features: GenericFeatureInfo[];

    private readonly modalComponentMediator = inject(ModalComponentMediator);

  @Input() set data(value: any) {

        this.filer = value.filer.map(x => ({
            beteckning: x,
            checked: true
        } as SelectedListItem));
        this.importCallback = value.callback;
        this.features = value.features;
    }

  abort() {
      this.close();
  }
  close() {
      this.modalComponentMediator.getRef().close(null);
  }

  save() {
      if (this.importCallback) {
          this.importCallback(this.filer.filter(x => x.checked), this.features);
      }
      this.close();
  }
}
